const UrlConfirmation = {
    urlDesarrollo: "https://desarrollo.pse.com.co/",
    urlProduccion: "https://produccion.pse.com.co/"
}

export default UrlConfirmation;